import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthConfigService } from '../../services/auth-config/auth-config.service';
import { fromEvent } from 'rxjs';
import { MUser } from '@argalis-apps/models';
import { AuthService } from '../../services/auth/auth.service';
import { checkIcon, xIcon } from "@progress/kendo-svg-icons";

@Component({
  selector: 'ags-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, AfterViewInit {
  public changePasswordForm: UntypedFormGroup;
  public themeFlag = '';
  public submited = false;
  public haveNumber = false;
  public haveMoreThen6 = false;
  public haveUpperCase = false;
  public checkSpecial = false;
  public notSamePassword = false;
  public icon = {checkIcon, xIcon};
  @Input() checkStrongPassword = true;
  @Input() user: MUser.IUser;
  @Output() passwordChangeReponse = new EventEmitter();
  @ViewChild('passwordChecker') passwordChecker: ElementRef<HTMLElement>;

  constructor(
    private authConfig: AuthConfigService,
    private authService: AuthService,
    public formBuilder: UntypedFormBuilder
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${this.authConfig.themingClassName}`;
  }

  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group({
      password1: new UntypedFormControl('', [Validators.required]),
      password2: new UntypedFormControl({ value: '', disabled: this.checkerMode() }, [Validators.required])
    });
  }

  checkerMode() {
    if (!this.checkStrongPassword) return false;
    return !(this.haveMoreThen6 && this.haveNumber && this.haveUpperCase && this.checkSpecial);
  }

  changePassword() {
    const password1 = this.changePasswordForm.get('password1').value;
    const password2 = this.changePasswordForm.get('password2').value;
    this.notSamePassword = false;
    this.submited = true;
    if (password1 === password2) {
      this.authService.changePassword(this.user.userInfo.id, password1, this.user.userInfo.b_ost).subscribe(
        res => {
          this.submited = false;
          this.passwordChangeReponse.emit(true);
        },
        () => {
          this.submited = false;
          this.authService.signout();
          this.passwordChangeReponse.emit(false);
        }
      );
    } else {
      this.submited = false;
      this.notSamePassword = true;
    }
  }

  ngAfterViewInit(): void {
    if (this.checkStrongPassword) {
      const checkIfNumberRegExp = RegExp(/\d/);
      const upperCaseCheckerRegExp = RegExp(/.*[A-Z].*/);
      const checkCarrecterRegExp = RegExp(/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/);
      fromEvent(this.passwordChecker.nativeElement, 'keyup')
        .pipe()
        .subscribe(res => {
          this.haveNumber = checkIfNumberRegExp.test((res.target as HTMLInputElement).value);
          this.haveUpperCase = upperCaseCheckerRegExp.test((res.target as HTMLInputElement).value || '');
          this.checkSpecial = checkCarrecterRegExp.test((res.target as HTMLInputElement).value);
          this.haveMoreThen6 = ((res.target as HTMLInputElement).value || '').length > 5;
          if (this.haveMoreThen6 && this.haveNumber && this.haveUpperCase && this.checkSpecial) {
            this.changePasswordForm.controls['password2'].reset({ value: '', disabled: false });
          }
        });
    }
  }
}
